(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aluck-wide-leg-jeans"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initRoot(root){
    if(!root||root.dataset.ready==='1')return;root.dataset.ready='1';
    var main=root.querySelector('.alg-main-img'),thumbs=Array.prototype.slice.call(root.querySelectorAll('.alg-thumb')),current=0,timer=null,gallery=root.querySelector('.alg-gallery'),count=root.querySelector('.alg-gcount');
    function showImage(index,userAction){
      if(!thumbs.length||!main)return;
      current=(index+thumbs.length)%thumbs.length;
      main.src=thumbs[current].dataset.src;
      thumbs.forEach(function(b,i){b.classList.toggle('alg-on',i===current)});
      thumbs[current].scrollIntoView({behavior:userAction?'smooth':'auto',block:'nearest',inline:'center'});
      if(count)count.textContent=(current+1)+' / '+thumbs.length;
      if(userAction)restart();
    }
    function start(){stop();if(thumbs.length>1)timer=window.setInterval(function(){showImage(current+1,false)},4000)}
    function stop(){if(timer){window.clearInterval(timer);timer=null}}
    function restart(){stop();start()}
    thumbs.forEach(function(btn,i){btn.addEventListener('click',function(e){e.preventDefault();showImage(i,true)})});
    var prev=root.querySelector('.alg-gprev'),next=root.querySelector('.alg-gnext');
    if(prev)prev.addEventListener('click',function(){showImage(current-1,true)});
    if(next)next.addEventListener('click',function(){showImage(current+1,true)});
    if(gallery){gallery.addEventListener('mouseenter',stop);gallery.addEventListener('mouseleave',start);gallery.addEventListener('touchstart',stop,{passive:true});gallery.addEventListener('touchend',restart,{passive:true})}
    start();
    var sid=root.dataset.sectionId,json=document.getElementById('alg-variants-'+sid),variants=json?JSON.parse(json.textContent):[],selects=root.querySelectorAll('.alg-option'),idInput=root.querySelector('.alg-variant-id'),atc=root.querySelector('.alg-atc'),price=root.querySelector('.alg-now'),was=root.querySelector('.alg-was');
    function money(c){return window.Shopify&&window.Shopify.formatMoney?window.Shopify.formatMoney(c,window.Shopify.money_format):'$'+(c/100).toFixed(2)}
    function sync(){var vals=[];root.querySelectorAll('.alg-field').forEach(function(field){var checked=field.querySelector('.alg-option:checked')||field.querySelector('select.alg-option');vals.push(checked?checked.value:'');var label=field.querySelector('.alg-selected');if(label&&checked)label.textContent=checked.value});var v=variants.find(function(x){return x.options.every(function(o,i){return o===vals[i]})});if(!v)return;if(idInput)idInput.value=v.id;if(price)price.textContent=money(v.price);if(was)was.textContent=v.compare_at_price?money(v.compare_at_price):'';var p2=root.querySelector('.alg-qprice-2'),p3=root.querySelector('.alg-qprice-3');if(p2)p2.textContent=money(v.price*2);if(p3)p3.textContent=money(v.price*3);if(atc){atc.disabled=!v.available;atc.innerHTML='<span>'+(v.available?'Add to cart':'Sold out')+'</span>'}if(v.featured_image&&main){main.src=v.featured_image.src;var match=thumbs.findIndex(function(b){return b.dataset.src.indexOf(v.featured_image.src.split('?')[0])!==-1});if(match>=0){current=match;showImage(current,true)}}}
    selects.forEach(function(s){s.addEventListener('change',sync)});
    root.querySelectorAll('.alg-qty-radio').forEach(function(q){q.addEventListener('change',function(){var qty=root.querySelector('.alg-quantity');if(qty)qty.value=this.value;root.querySelectorAll('.alg-qoffer').forEach(function(x){x.classList.remove('alg-qon')});this.closest('.alg-qoffer').classList.add('alg-qon')})});
    root.querySelectorAll('.alg-faq-item').forEach(function(item){item.addEventListener('click',function(){this.classList.toggle('alg-open')})});
  }
  function initAll(scope){(scope||document).querySelectorAll('#alg-wide-leg').forEach(initRoot)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll(document)})}else{initAll(document)}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["checkout-custom-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const backToTop = document.getElementById('BackToTop');
    if (!backToTop) return;
    
    // 滚动显示/隐藏返回顶部按钮
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }, { passive: true });
    
    // 点击返回顶部
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["egg-opener-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('eov-wrap');if(!root)return;
  root.querySelectorAll('.eov-faq-item').forEach(function(x){x.addEventListener('click',function(){x.classList.toggle('eov-open')})});
  var minus=root.querySelector('.eov-minus'),plus=root.querySelector('.eov-plus'),qty=root.querySelector('.eov-qty-input');
  if(minus&&qty)minus.addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1)});
  if(plus&&qty)plus.addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+1});
  var json=root.querySelector('.eov-variants'),variants=[];try{variants=json?JSON.parse(json.textContent):[]}catch(e){}
  var groups=[].slice.call(root.querySelectorAll('.eov-option')),idInput=root.querySelector('.eov-variant-id'),now=root.querySelector('.eov-now'),old=root.querySelector('.eov-old'),atc=root.querySelector('.eov-atc'),pimg=root.querySelector('.eov-product-image'),stickyPrice=root.querySelector('.eov-sticky-price');
  function selected(){var a=[];groups.forEach(function(g){var b=g.querySelector('.eov-opt.eov-selected');a[parseInt(g.getAttribute('data-option-index'),10)]=b?b.getAttribute('data-value'):''});return a}
  function money(c){if(window.Shopify&&Shopify.formatMoney){return Shopify.formatMoney(c)}return '$'+(c/100).toFixed(2)}
  function mappedImage(vals){if(!pimg)return'';var color=(vals[0]||'yellow').toLowerCase();if(color.indexOf('pink')>-1)color='pink';else if(color.indexOf('orange')>-1)color='orange';else color='yellow';var offer=(vals[1]||'').toLowerCase().indexOf('buy 2')>-1?'buy2':'buy1';var bundle=(vals[2]||'').toLowerCase().indexOf('timer')>-1?'timer':'tool';return pimg.getAttribute('data-'+color+'-'+offer+'-'+bundle)||''}
  function sync(){if(!variants.length)return;var vals=selected(),v=variants.find(function(x){return x.options.every(function(o,i){return o===vals[i]})});if(!v)return;if(idInput)idInput.value=v.id;if(now)now.textContent=money(v.price);if(stickyPrice)stickyPrice.textContent=money(v.price);if(old){old.textContent=v.compare_at_price&&v.compare_at_price>v.price?money(v.compare_at_price):'';old.style.display=old.textContent?'inline':'none'}if(atc){atc.disabled=!v.available;atc.textContent=v.available?'Add to Cart':'Sold Out'}var mapped=mappedImage(vals);if(pimg&&mapped)pimg.src=mapped;else if(pimg&&v.featured_image&&v.featured_image.src)pimg.src=v.featured_image.src;groups.forEach(function(g){var idx=parseInt(g.getAttribute('data-option-index'),10);g.querySelectorAll('.eov-opt').forEach(function(b){var test=vals.slice();test[idx]=b.getAttribute('data-value');b.disabled=!variants.some(function(x){return x.available&&x.options.every(function(o,i){return !test[i]||o===test[i]})})})})}
  root.querySelectorAll('.eov-opt').forEach(function(b){b.addEventListener('click',function(){var g=b.closest('.eov-option');g.querySelectorAll('.eov-opt').forEach(function(x){x.classList.remove('eov-selected')});b.classList.add('eov-selected');sync()})});
  var control=root.querySelector('.eov-control'),frame=0;if(control){setInterval(function(){frame=frame?0:1;var desk=control.querySelectorAll('.eov-control-desktop'),mob=control.querySelectorAll('.eov-control-mobile');desk.forEach(function(x,i){x.classList.toggle('eov-active',i===frame)});mob.forEach(function(x,i){x.classList.toggle('eov-active',i===frame)})},3200)}
  var sticky=root.querySelector('.eov-sticky-btn'),buy=root.querySelector('#eov-buy');if(sticky&&buy)sticky.addEventListener('click',function(){buy.scrollIntoView({behavior:'smooth',block:'start'})});sync();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["high-tack-mesh-tape"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.getElementById('tht-tape-260731');
    if(!root)return;

    var track=root.querySelector('.tht-gallery-track');
    var slides=track?Array.prototype.slice.call(track.querySelectorAll('.tht-slide')):[];
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('.tht-thumb'));
    var dotsWrap=root.querySelector('.tht-dots');
    var activeIndex=0;

    function goToSlide(index){
      if(!track||!slides.length)return;
      index=Math.max(0,Math.min(index,slides.length-1));
      track.scrollTo({left:slides[index].offsetLeft,behavior:'smooth'});
      setActive(index);
    }

    function setActive(index){
      activeIndex=index;
      thumbs.forEach(function(button,i){button.classList.toggle('tht-active',i===index)});
      if(dotsWrap){Array.prototype.forEach.call(dotsWrap.children,function(dot,i){dot.classList.toggle('tht-active',i===index)})}
    }

    if(dotsWrap){
      slides.forEach(function(slide,index){
        var dot=document.createElement('button');
        dot.type='button';
        dot.className='tht-dot'+(index===0?' tht-active':'');
        dot.setAttribute('aria-label','View image '+(index+1));
        dot.addEventListener('click',function(){goToSlide(index)});
        dotsWrap.appendChild(dot);
      });
    }

    thumbs.forEach(function(button,index){button.addEventListener('click',function(){goToSlide(index)})});
    var prev=root.querySelector('.tht-gprev');
    var next=root.querySelector('.tht-gnext');
    if(prev)prev.addEventListener('click',function(){goToSlide(activeIndex-1)});
    if(next)next.addEventListener('click',function(){goToSlide(activeIndex+1)});

    if(track){
      var scrollTimer;
      track.addEventListener('scroll',function(){
        window.clearTimeout(scrollTimer);
        scrollTimer=window.setTimeout(function(){
          var midpoint=track.scrollLeft+(track.clientWidth/2),best=0,distance=Infinity;
          slides.forEach(function(slide,index){var d=Math.abs(slide.offsetLeft+(slide.offsetWidth/2)-midpoint);if(d<distance){distance=d;best=index}});
          setActive(best);
        },70);
      });
    }

    var variantsNode=root.querySelector('[data-tht-variants]');
    var variants=[];
    if(variantsNode){try{variants=JSON.parse(variantsNode.textContent)}catch(error){variants=[]}}
    var optionGroups=Array.prototype.slice.call(root.querySelectorAll('.tht-option'));
    var selected=optionGroups.map(function(group){var button=group.querySelector('.tht-opt.tht-active');return button?button.getAttribute('data-option-value'):''});
    var variantInput=root.querySelector('[data-tht-variant-id]');
    var priceNode=root.querySelector('[data-tht-price]');
    var compareNode=root.querySelector('[data-tht-compare]');
    var saveNode=root.querySelector('[data-tht-save]');
    var addButton=root.querySelector('[data-tht-atc]');
    var buyButton=root.querySelector('[data-tht-buy]');

    function money(cents){
      if(window.Shopify&&typeof window.Shopify.formatMoney==='function')return window.Shopify.formatMoney(cents,root.getAttribute('data-money-format'));
      return '$'+(cents/100).toFixed(2);
    }

    function updateVariant(){
      var variant=variants.find(function(item){return item.options.every(function(value,index){return value===selected[index]})});
      if(!variant){
        if(addButton){addButton.disabled=true;addButton.textContent='Unavailable'}
        if(buyButton)buyButton.disabled=true;
        return;
      }
      if(variantInput)variantInput.value=variant.id;
      if(priceNode)priceNode.textContent=money(variant.price);
      if(compareNode){
        if(variant.compare_at_price&&variant.compare_at_price>variant.price){compareNode.hidden=false;compareNode.textContent=money(variant.compare_at_price)}else{compareNode.hidden=true}
      }
      if(saveNode){
        if(variant.compare_at_price&&variant.compare_at_price>variant.price){saveNode.hidden=false;saveNode.textContent='SAVE '+Math.round((variant.compare_at_price-variant.price)*100/variant.compare_at_price)+'%'}else{saveNode.hidden=true}
      }
      if(addButton){addButton.disabled=!variant.available;addButton.textContent=variant.available?'Add to cart':'Sold out'}
      if(buyButton)buyButton.disabled=!variant.available;
      if(variant.featured_media){
        var target=root.querySelector('.tht-slide[data-media-id="'+variant.featured_media.id+'"]');
        if(target){var idx=slides.indexOf(target);if(idx>-1)goToSlide(idx)}
      }
      if(window.history&&window.history.replaceState){var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url.toString())}
    }

    optionGroups.forEach(function(group,groupIndex){
      var label=group.querySelector('[data-option-label]');
      Array.prototype.forEach.call(group.querySelectorAll('.tht-opt'),function(button){
        button.addEventListener('click',function(){
          Array.prototype.forEach.call(group.querySelectorAll('.tht-opt'),function(item){item.classList.remove('tht-active')});
          button.classList.add('tht-active');
          selected[groupIndex]=button.getAttribute('data-option-value');
          if(label)label.textContent=selected[groupIndex];
          updateVariant();
        });
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('.tht-faq-item'),function(item){
      var button=item.querySelector('.tht-faq-q');
      if(!button)return;
      button.addEventListener('click',function(){
        var open=item.classList.toggle('tht-open');
        button.setAttribute('aria-expanded',open?'true':'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumen-cross-lamp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('lmn-wrap');if(!root)return;
  var main=root.querySelector('[data-lmn-main]'),thumbs=Array.prototype.slice.call(root.querySelectorAll('.lmn-thumb')),active=0;
  function show(i){if(!thumbs.length||!main)return;active=(i+thumbs.length)%thumbs.length;main.style.opacity='0';setTimeout(function(){main.src=thumbs[active].getAttribute('data-src');main.style.opacity='1'},120);thumbs.forEach(function(t,n){t.classList.toggle('is-active',n===active)});thumbs[active].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})}
  thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i)})});
  var prev=root.querySelector('[data-lmn-prev]'),next=root.querySelector('[data-lmn-next]');if(prev)prev.addEventListener('click',function(){show(active-1)});if(next)next.addEventListener('click',function(){show(active+1)});
  root.querySelectorAll('.lmn-faq-item').forEach(function(f){f.addEventListener('click',function(){this.classList.toggle('is-open')})});
  var qty=root.querySelector('[data-lmn-qty]'),minus=root.querySelector('[data-lmn-minus]'),plus=root.querySelector('[data-lmn-plus]');if(minus&&qty)minus.addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1)});if(plus&&qty)plus.addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+1});
  var data=root.querySelector('[data-lmn-variants]'),idInput=root.querySelector('[data-lmn-id]'),atc=root.querySelector('[data-lmn-atc]'),opts=root.querySelectorAll('[data-lmn-option]');if(data&&opts.length){var variants=[];try{variants=JSON.parse(data.textContent)}catch(e){}opts.forEach(function(o){o.addEventListener('change',function(){var selected=[];opts.forEach(function(x){if(x.checked)selected[parseInt(x.getAttribute('data-position'),10)]=x.value});var v=variants.find(function(x){return x.options.every(function(value,i){return value===selected[i]})});if(!v)return;if(idInput)idInput.value=v.id;if(atc){atc.disabled=!v.available;atc.textContent=v.available?'CLAIM OFFER':'OUT OF STOCK'}})})}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-shape-seal-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.getElementById('tss-wrap');
  if(!root)return;
  var radios=root.querySelectorAll('[name="tss_variant"]');
  var hidden=root.querySelector('[data-tss-id]');
  var price=root.querySelector('[data-tss-price]');
  var compare=root.querySelector('[data-tss-compare]');
  radios.forEach(function(radio){radio.addEventListener('change',function(){if(hidden)hidden.value=this.value;if(price)price.textContent=this.getAttribute('data-price')||'';if(compare)compare.textContent=this.getAttribute('data-compare')||'';});});
  root.querySelectorAll('a[href="#tss-buy"]').forEach(function(link){link.addEventListener('click',function(e){var target=root.querySelector('#tss-buy');if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}});});
})();

  } catch(e) { console.error(e); }
})();
})();
